import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import Service from '../../api/Service';
import * as consts from '../../utils/constants/url';

export const sendResetValidationCode = createAsyncThunk(
  'reset/sendResetValidationCode',
  async (payload, thunkAPI) => {
    try {
      const response = await Service.post(
        consts.ENDPOINT_TENANT_FORGOTTEN,
        payload
      );
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue({
        error: {
          code: e.code,
          message: e.message,
        },
      });
    }
  }
);

export const registerSlice = createSlice({
  name: 'register',
  initialState: {
    values: {},
    step: 0,
  },
  reducers: {
    setValues: (state, {payload}) => ({
      ...state,
      values: {
        ...state.values,
        ...payload,
      },
    }),
    resetValues: state => ({
      ...state,
      values: {},
    }),
    setStep: (state, {payload}) => ({
      ...state,
      step: payload,
    }),
  },
});

export const registerState = state => state.reset;

export const {resetValues, setValues, setStep} = registerSlice.actions;

export default registerSlice.reducer;
